export default "<div class=\"container text-center\">\r\n    <h1>Thanks for your purchase</h1>\r\n</div>"